// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/alg-art-splash.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling for Algorithmic Art page */

/* Contains Algorithmic Art game & orientation warning */
#game {
    overflow-y: scroll;
    position: relative;
}

/* Algorithmic Art WebGL canvas; this is where the Unity game can be played */
#game > canvas {
    width: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center;
}

/* Overlay which tells the user to switch to landscape orientation 
   to play Algorithmic Art */
#profile-mode-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #1A0022;
    color: white;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 2vh;
}

/* Graphic prompting device rotation */
#profile-mode-overlay > img {
    width: 40%;
}`, "",{"version":3,"sources":["webpack://./src/css/AlgoArtPage.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC,wDAAwD;AACxD;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,6EAA6E;AAC7E;IACI,WAAW;IACX,yDAAmD;IACnD,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;4BAC4B;AAC5B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,sCAAsC;AACtC;IACI,UAAU;AACd","sourcesContent":["/* Styling for Algorithmic Art page */\n\n/* Contains Algorithmic Art game & orientation warning */\n#game {\n    overflow-y: scroll;\n    position: relative;\n}\n\n/* Algorithmic Art WebGL canvas; this is where the Unity game can be played */\n#game > canvas {\n    width: 100%;\n    background-image: url(../images/alg-art-splash.svg);\n    background-repeat: no-repeat;\n    background-size: auto 100%;\n    background-position: center;\n}\n\n/* Overlay which tells the user to switch to landscape orientation \n   to play Algorithmic Art */\n#profile-mode-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #1A0022;\n    color: white;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    font-size: 2vh;\n}\n\n/* Graphic prompting device rotation */\n#profile-mode-overlay > img {\n    width: 40%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
